// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aUOtstP5Deb5yzzts_2S{margin:0}`, "",{"version":3,"sources":["webpack://./../../mfe/serviceability/src/components/NoAvailablePlansModal/noAvailablePlans.module.scss"],"names":[],"mappings":"AAAA,sBACE,QAAA","sourcesContent":[".bodyTextValue {\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"bodyTextValue": `aUOtstP5Deb5yzzts_2S`
};
export default ___CSS_LOADER_EXPORT___;
